import { Navigate } from 'react-router-dom';
import { useMemo } from 'react';
import { firstAccessiblePath } from '@shared/components/layout/nav-config';
import { usePermissions } from '@shared/hooks/usePermissions';
import { useAppConfig } from '@shared/app/app-config';
import { RouteSplashScreen } from '@shared/router/RouteSplashScreen';
import { PATHS } from '@shared/router/paths';

/**
 * Root redirect for authenticated users: the first destination of THIS
 * application's navigation the account may actually open, instead of a fixed
 * dashboard a user without `dashboard.view` could not see. Falls back to the
 * Access Denied page when nothing is reachable (terminates, never loops).
 */
export function LandingRoute() {
  const { navigation, usesPermissions } = useAppConfig();
  const { can, canAny, hasScope, isReady } = usePermissions();
  const target = useMemo(
    () =>
      firstAccessiblePath(
        navigation,
        usesPermissions
          ? { can, canAny, hasScope }
          : { can: () => true, canAny: () => true, hasScope: () => true },
      ),
    [navigation, usesPermissions, can, canAny, hasScope],
  );

  if (!isReady) return <RouteSplashScreen />;
  return <Navigate to={target ?? PATHS.app.unauthorized} replace />;
}
